import React, { useEffect, useState } from 'react';
import Title from '../../../common/RequestTitle';
import VesselInfo from './VesselInfo';
import PodPorsBlock from './podPol/PodPorsBlock';
import Fields from './content/Fields';

function HiresTable({ hireOrderNumber, hireOrder }) {
    const [order, setOrder] = useState(hireOrder);

    useEffect(() => {
        setOrder(hireOrder);
    }, [hireOrder]);

    return (
        <div className='sidebar-table' style={{ position: 'relative' }}>
            <Title 
                orderNumber={hireOrderNumber + 1}
                text='HIRE ORDER NUMBER'
                warnings={[]}
            />
            <div className='paper-block margin-bottom' style={{ padding: '10px' }}>
                <VesselInfo orderIndex={0} hireOrder={order} />
            </div>
            <div className='paper-block margin-bottom'>
                <PodPorsBlock order={order} orderIndex={0} />
            </div>
            <div className='paper-block margin-bottom'>
                <Fields hireOrder={order} orderIndex={0} />
            </div>
            <hr />
        </div>
    );
}

export default HiresTable;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/HiresTable.jsx